
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const WelcomeModal = () => {
  const { updateOnboardingStatus } = useAuth();

  const handleStart = () => {
    updateOnboardingStatus('in_progress');
  };

  const handleSkip = () => {
    updateOnboardingStatus('completed');
  };

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const modalContentStyle = {
    backgroundColor: 'white',
    padding: window.innerWidth < 768 ? '32px 20px' : '40px',
    borderRadius: '8px',
    textAlign: 'center',
    maxWidth: window.innerWidth < 768 ? 'calc(100vw - 32px)' : '500px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  };

  const buttonStyle = {
    padding: window.innerWidth < 768 ? '12px 16px' : '10px 20px',
    margin: window.innerWidth < 768 ? '8px 0' : '0 10px',
    borderRadius: '5px',
    border: 'none',
    cursor: 'pointer',
    fontSize: window.innerWidth < 768 ? '15px' : '16px',
    width: window.innerWidth < 768 ? '100%' : 'auto',
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#007bff',
    color: 'white',
  };

  const secondaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#f0f0f0',
    color: '#333',
  };

  return (
    <div style={modalStyle}>
      <div style={modalContentStyle}>
        <h1 style={{ fontSize: window.innerWidth < 768 ? '20px' : '24px', marginBottom: '20px', fontWeight: '700' }}>Welcome to SwiftBidPro!</h1>
        <p style={{ fontSize: window.innerWidth < 768 ? '15px' : '16px', marginBottom: '30px', lineHeight: '1.5' }}>Let's get you sending your first quote in under 2 minutes.</p>
        <div style={{ display: 'flex', flexDirection: window.innerWidth < 768 ? 'column' : 'row', gap: window.innerWidth < 768 ? '12px' : '0', justifyContent: 'center' }}>
          <button style={primaryButtonStyle} onClick={handleStart}>
            Start Guided Setup
          </button>
          <button style={secondaryButtonStyle} onClick={handleSkip}>
            I'll explore on my own
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
